import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { ModelSelectorSearchable } from '@/components/molecules/model-selector-searchable.molecule'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'

import type { AgentNodeFormSchemaType } from '../agency-node-form.schema'

interface AgentNodeModelFieldProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  modelList: LlmModel[]
  isLoadingModels: boolean
}

export const AgentNodeModelField = ({
  form,
  modelList,
  isLoadingModels,
}: AgentNodeModelFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="model"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Model</FormLabel>
        <FormControl>
          <ModelSelectorSearchable
            value={field.value}
            onChange={field.onChange}
            modelList={modelList}
            isLoading={isLoadingModels}
            placeholder="Select a model..."
            className="agent-node-model-select"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)

AgentNodeModelField.displayName = 'AgentNodeModelField'
